<template>
    <router-link class='resourceTile cs-orange-learn' :to="bundleLink">
        <div class='resourceTileInner'>
        <img :src='thumbnail'> 
        <div class='resourceText'><h2>{{bundle.title}}</h2><h3> </h3></div>
        </div>
    </router-link>
</template>

<script>
import util from '../util'
import _ from 'lodash'

export default {
    name: 'bundle-tile',
    props: ['bundle'],
    computed: {
        bundleLink() {
            return { name: 'educationbundle', params: { bundle: this.bundle, slug: this.bundle.slug } };
        },
        thumbnail() {
            if (!_.isEmpty(this.bundle.image)) {
                return this.bundle.thumbnail.url;
            } else {
                return `//i3.ytimg.com/vi/${util.videoId(this.bundle.videourl)}/mqdefault.jpg`;
            }
        }
    }
}
</script>